// Angular
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
// Models
import { Club } from './../../models/club';
// External
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import * as localforage from 'localforage';
import { ActivatedRoute } from '@angular/router';

@Injectable()

export class OAuthService {

    private user: firebase.User;
    private club: Club;
    constructor(private router: Router, private fireAuth: AngularFireAuth, private route: ActivatedRoute) {
        this.fireAuth.authState.subscribe(user => {
            this.user = user;
            if (!user) {
                this.router.navigate(['/login']);

            }
            router.events.subscribe((val) => {

                if (val instanceof NavigationEnd) {
                    console.log(val)
                    if (val.url == "/") {
                        console.log(val)

                        this.router.navigate(['/home/dashboard']);

                    }
                }
            });

        });

    }

    getUser() {
        return this.user;
    }

    setClub(club: any) {
        // if(club.subscription)
        //     club.subscription = new Date(club.subscription);

        this.club = club;
        return localforage.setItem('club', club);
    }

    getClub() {
        return this.club;
    }

    logout() {
        this.club = null;
        localforage.setItem("club", null)
        return localforage.clear()
            .then(() => {
                return this.fireAuth.auth.signOut();
            });
    }
}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/o-auth/o-auth.service.ts